// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3jFNa","options":"AnswerScale_options__xh-Ry","selected":"AnswerScale_selected__2cZq6"};